import _ from 'lodash';

import { cleanFormattedExpression } from 'utils/expressions';

const isFuncIdentifierChar = char => /[a-zA-Z_]/.test(char);

export const formatExpressionDocument = model => {
  const text = cleanFormattedExpression(model.getValue());

  let formattedCode = '';

  if (!text) {
    return [
      {
        text: formattedCode,
        range: model.getFullModelRange(),
      },
    ];
  }

  function isFunctionRelated(ind) {
    let j = ind,
      nestingBrackets = 0,
      isStringValue = false;

    while (j >= 0) {
      if (text[j] === "'") {
        isStringValue = !isStringValue;
      }

      if (text[j] === '(' && !nestingBrackets && !isStringValue) {
        break;
      }

      if (j !== ind && text[j] === ')' && !isStringValue) {
        nestingBrackets++;
      }
      if (text[j] === '(' && nestingBrackets && !isStringValue) {
        nestingBrackets--;
      }

      j--;
    }

    if (j < 0 || j - 1 < 0) {
      return false;
    }

    return isFuncIdentifierChar(text[j - 1]);
  }

  const tabChar = '\t';

  let nestingLvl = 0,
    isStringValue = false;

  for (let i = 0; i < text.length; i++) {
    const char = text[i];
    const nextChar = text[i + 1];

    if (char === "'") {
      // uneven quotes marks count signalizes about string value which should be ignored
      isStringValue = !isStringValue;
    }

    switch (!isStringValue ? char : null) {
      case '(':
        if (nextChar === '\n') {
          continue;
        }

        if (!isFunctionRelated(i)) {
          formattedCode += '(';

          continue;
        }

        formattedCode += '(\n';
        nestingLvl++;
        if (nestingLvl >= 0) {
          formattedCode += tabChar.repeat(nestingLvl);
        }

        break;

      case ')':
        if (nextChar === '\n') {
          continue;
        }

        if (!isFunctionRelated(i)) {
          formattedCode += ')';

          continue;
        }

        formattedCode += '\n';
        nestingLvl--;
        if (nestingLvl >= 0) {
          formattedCode += tabChar.repeat(nestingLvl);
        }
        formattedCode += ')';

        break;

      case ',':
        if (nextChar === '\n') {
          continue;
        }

        formattedCode += ',\n';
        if (nestingLvl >= 0) {
          formattedCode += tabChar.repeat(nestingLvl);
        }

        break;

      case ' ':
        if (formattedCode.endsWith('\n') || formattedCode.endsWith(tabChar)) {
          // do not add a space if it's at the beginning of a line
          continue;
        }

        formattedCode += ' ';

        break;

      default:
        formattedCode += char;

        break;
    }
  }

  return [
    {
      text: formattedCode.trim(),
      range: model.getFullModelRange(),
    },
  ];
};

export const getModelPositionFromFlatPosition = ({ modelValue = '', position: { start, end } }) => {
  let line = 1,
    column = 1;

  let startLine = 1,
    startColumn = 1,
    endLine = 1,
    endColumn = 1;

  if (_.isNil(start) || _.isNil(end)) {
    return { startLineNumber: startLine, startColumn, endLineNumber: endLine, endColumn };
  }

  // \n, \t, space and `'` don't count as characters
  let charactersInd = 0;
  for (let char of modelValue) {
    if (charactersInd === start) {
      startLine = line;
      startColumn = column;
    }

    if (charactersInd === end) {
      endLine = line;
      endColumn = column + 1;
      break;
    }

    if (char === '\n') {
      line++;
      column = 1;
      continue;
    }

    column++;

    if (!`\t' `.includes(char)) {
      charactersInd++;
    }
  }

  return { startLineNumber: startLine, startColumn, endLineNumber: endLine, endColumn };
};

export const getHelperText = helperText => {
  const positionInfoInd = helperText?.indexOf('[') ?? -1;

  return positionInfoInd < 0 ? helperText : helperText?.slice(0, positionInfoInd);
};
